import { sortCollectionItems } from "../../../shared/lib/sort/sortCollectionItems.js";
function formatSpecificationGroups(specifications, specificationsDictionary, groupsDictionary, translations) {
  const specificationInfo = [];
  specifications.forEach((spec) => {
    var _a;
    const dictionaryValue = specificationsDictionary.find((dictEntry) => dictEntry.id === spec.specification);
    if (!dictionaryValue) {
      return;
    }
    let specValue = "";
    switch (dictionaryValue.data.dataType) {
      case "boolean":
        specValue = spec.booleanValue ? translations("common.booleanValues.trueValue") : translations("common.booleanValues.falseValue");
        break;
      case "number":
        specValue = ((_a = spec.numberValue) == null ? void 0 : _a.toLocaleString()) || null;
        break;
      default:
        specValue = spec.stringValue ?? null;
    }
    if (!(dictionaryValue == null ? void 0 : dictionaryValue.data.group) || !specValue) {
      return;
    }
    const specInfo = {
      key: spec.id,
      label: dictionaryValue.data.alternateName || dictionaryValue.data.name,
      value: specValue,
      group: dictionaryValue.data.group,
      position: dictionaryValue.data.position
    };
    specificationInfo.push(specInfo);
  });
  const specsByGroups = groupsDictionary.reduce(
    (acc, group) => {
      const specsByGroup = specificationInfo.filter((info) => info.group === group.id).sort(sortCollectionItems);
      if (!specsByGroup.length) {
        return acc;
      }
      return [
        ...acc,
        {
          id: group.id,
          title: group.data.alternateName || group.data.name,
          items: specsByGroup,
          position: group.data.position
        }
      ];
    },
    []
  );
  return specsByGroups.sort(sortCollectionItems);
}
export {
  formatSpecificationGroups
};
